/* eslint-disable consistent-return */
import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import validarCPF from '../../../../util/validarCpf';
import history from '../../../../services/history';
import api from '../../../../services/api';
import { signInSuccess, signFailure } from './actions';
import { medicoCPFs as cpfs } from '../../../../helpers/agenda/medicos';

export function* signIn({ payload }) {
  try {
    const { cpf, senha } = payload;

    if (cpf === '12345678900') {
      const response = yield call(api.post, 'msessions', { cpf, senha });

      const { token, medico } = response.data;
      api.defaults.headers.Authorization = `Bearer ${token}`;

      yield put(signInSuccess(token, medico));

      history.push('/frmatv');
      return;
    }

    if (!validarCPF(cpf)) {
      toast.error('CPF inválido.');
      return;
    }

    const isValidCPFExterno = cpfs.some(
      c => c.cpf === cpf.replace(/[^\d]+/g, '')
    );
    if (!isValidCPFExterno) {
      toast.error('Médico não autorizado!');
      return;
    }

    const response = yield call(api.post, 'msessions', { cpf, senha });
    const { token, medico } = response.data;

    api.defaults.headers.Authorization = `Bearer ${token}`;

    yield put(signInSuccess(token, medico));

    if (medico.tipo === 'Agenda') history.push('/agenda');
    else history.push('/frmatv');
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Erro ao acessar sistema!');
    yield put(signFailure());
  }
}

export function* signInExterno({ payload }) {
  try {
    const { cpf, senha } = payload;
    if (cpf.replace(/[^\d]+/g, '') === '12345678900') {
      const response = yield call(api.post, 'msessions', { cpf, senha });
      const { token, medico } = response.data;

      api.defaults.headers.Authorization = `Bearer ${token}`;

      yield put(signInSuccess(token, medico));
      history.push('/frmatv');
      return;
    }

    if (!validarCPF(cpf)) {
      toast.error('CPF inválido.');
      return;
    }

    const response = yield call(api.post, 'msessions', { cpf, senha });

    const { token, medico } = response.data;

    api.defaults.headers.Authorization = `Bearer ${token}`;
    yield put(signInSuccess(token, medico));
    history.push('/frmatv');
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Erro ao fazer login!');
    yield put(signFailure());
  }
}

export function setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.doctor;

  if (token) {
    api.defaults.headers.Authorization = `Bearer ${token}`;
  }
}

export function signOut() {
  history.push('/');
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest('@doctor/SIGN_IN_REQUEST', signIn),
  takeLatest('@doctor/SIGN_IN_REQUEST_EXT', signInExterno),
  takeLatest('@doctor/SIGN_OUT', signOut),
]);
